import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import _map from 'lodash/map';
import _range from 'lodash/range';
import media from 'styles/media';
import { fadeIn } from 'styles/animations';

const ballPulse = keyframes`
  from {
    transform: scale(0.5);
  }
  to {
   transform: scale(1);
  }
`;

// Currently not modular but duration and count could be passed as arguments to template()
const template = () => {
  const duration = 0.9;
  const count = 3;
  const interval = duration / count;
  return _map(_range(count), it => {
    return css`
    div:nth-child(${it}) {
      animation-delay: ${(it * interval) - (interval * count)}s;
    }
  `;
  });
};

const Loader = styled.div`
  display: flex;
  flex-direction: row;
  align-self: center;
  opacity: 0;
  ${props => (props.isVisible ? css`
  animation: ${fadeIn} 4s 0.86s;
  animation-fill-mode: forwards;
  ` : '')};
  ${props => (props.spinnerStyles ? props.spinnerStyles : '')};
  ${media.IE9 ? 'display: none' : ''};

  > div {
    width: 9px;
    height: 9px;
    margin: 3px 2px;
    border-radius: 2px;
    background-color: white;
    animation: ${ballPulse} 0.9s linear infinite alternate;
    ${props => (props.dotStyles ? props.dotStyles : '')};
  }
  ${template()}
`;

export const Spinner = ({ spinnerStyles, dotStyles, isVisible }) => (
  <Loader isVisible={isVisible} spinnerStyles={spinnerStyles} dotStyles={dotStyles}>
    <div />
    <div />
    <div />
  </Loader>
);
